
























import { Component, Vue, Watch } from 'vue-property-decorator';
import { QrcodeStream } from 'vue-qrcode-reader';

@Component({
  name: 'QRreader',
  components: {
    QrcodeStream,
  },
})
export default class extends Vue {
  private readonly localhostOriginPrefix = 'http://localhost';
  private readonly testenvOriginPrefix = 'https://test-eticket.linktivity.io';
  private result = '';
  private error = '';
  private unknownError = '';

  private onDecode(result: string) {
    this.result = result;

    if (result && result.startsWith(location.origin)) {
      this.$router.push({ path: result.replace(location.origin, '') });
    } else if (
      location.origin.startsWith(this.localhostOriginPrefix) &&
      result &&
      result.startsWith(this.testenvOriginPrefix)
    ) {
      // for localtest
      this.$router.push({ path: result.replace(this.testenvOriginPrefix, '') });
    }
  }

  private async onInit(promise: Promise<any>) {
    try {
      await promise;
    } catch (error) {
      let hasUnknownError = false;
      if (error.name === 'NotAllowedError') {
        this.error = 'QR ERROR: you need to grant camera access permisson';
      } else if (error.name === 'NotFoundError') {
        this.error = 'QR ERROR: no camera on this device';
      } else if (error.name === 'NotSupportedError') {
        this.error = 'QR ERROR: secure context required (HTTPS, localhost)';
      } else if (error.name === 'NotReadableError') {
        this.error = 'QR ERROR: is the camera already in use?';
      } else if (error.name === 'OverconstrainedError') {
        this.error = 'QR ERROR: installed cameras are not suitable';
      } else if (error.name === 'StreamApiNotSupportedError') {
        this.error = 'QR ERROR: Stream API is not supported in this browser';
      } else {
        this.error = 'QR ERROR: Unknown error';
        hasUnknownError = true;
        this.unknownError = error.message;
      }
      if (!hasUnknownError) {
        this.unknownError = '';
      }
    }
  }
}
